import AttachmentWellViewState from '../schema/AttachmentWellViewState';
import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';
import ItemId from 'owa-service/lib/contract/ItemId';
import { SharingTipRecipientInfo } from 'owa-sharing-data';
import { action } from 'satcheljs';

// TODO VSO 32525: move this out of attachment well.
export const refreshSharingTipsAttachmentWell = action(
    'REFRESH_SHARING_TIPS_ATTACHMENT_WELL',
    (
        attachmentWellViewState: AttachmentWellViewState,
        parentItemId: ItemId,
        recipientInfo: SharingTipRecipientInfo[],
        infoBarIds: string[],
        infoBarAddHandler: (
            messageId: string,
            infoBarMessageViewStateCreator: InfoBarMessageViewStateCreator
        ) => void,
        infoBarRemoveHandler: (infoBarMessageIds: string[]) => void
    ) => ({
        attachmentWellViewState: attachmentWellViewState,
        parentItemId: parentItemId,
        recipientInfo: recipientInfo,
        infoBarIds: infoBarIds,
        infoBarAddHandler: infoBarAddHandler,
        infoBarRemoveHandler: infoBarRemoveHandler,
    })
);
